module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/thumbs-up-963a8bbdf45a96fa837b5c84e6d788b0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/thumbs-up.svg
// module id = 7CE0
// module chunks = 24